import React, { FC, useState } from 'react'
import { Link } from 'react-router-dom'

import JournalAddModal, { AddModalView } from '../Modals/JournalAddModal/JournalAddModal'

import { Icon, IconColor, IconName } from 'Components'
import { routes } from 'Config'

const JournalActions: FC = () => {
  const [isAddModalOpen, setIsAddModalOpen] = useState<boolean>(false)

  const [activeView, setActiveView] = useState<AddModalView>('search')

  const openAddModal = (): void => {
    if (isAddModalOpen) {
      setIsAddModalOpen(false)
    } else {
      setActiveView('search')
      setIsAddModalOpen(true)
    }
  }

  return (
    <>
      <div className="journal-actions-container">
        <button type="button" className="journal-action" onClick={openAddModal}>
          <span className="journal-action-icon" aria-hidden="true" />

          <span>Zum Tagebuch hinzufügen</span>
        </button>

        <Link to={routes.analytics.mass} title="Körpermasse eintragen" className="journal-action">
          <Icon name={IconName.scale} color={IconColor.BLUE_2} />

          <span>Körpermasse eintragen</span>
        </Link>
      </div>

      <JournalAddModal
        isOpen={isAddModalOpen}
        activeView={activeView}
        onViewChange={setActiveView}
        onClose={() => setIsAddModalOpen(false)}
      />
    </>
  )
}

export default JournalActions
